// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AcceptP2PRequest_wrapper__01xgy","loading":"AcceptP2PRequest_loading__8yE9U"};